var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shoppingNum"},[_c('van-dialog',{attrs:{"show-cancel-button":""},on:{"confirm":function($event){return _vm.$emit('update-num',  _vm.count_self)},"close":function($event){return _vm.$emit('cancel-update-num')}},model:{value:(_vm.keyShow),callback:function ($$v) {_vm.keyShow=$$v},expression:"keyShow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }